/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { Box } from '@mui/material';
import { utils } from '@rjsf/core';
import { isEqual } from 'date-fns';
import { DateTimePicker } from '../../stories/DateTimePicker';
import { CustomWidgetProps } from '../types';

const { localToUTC, utcToLocal, getDisplayLabel } = utils;

const DateTimeWidget: React.FC<React.PropsWithChildren<CustomWidgetProps>> = ({
  id,
  readonly: readOnly,
  disabled,
  label,
  value,
  onChange,
  autofocus,
  schema,
  uiSchema,
  formContext: { onHasChanged },
}: CustomWidgetProps) => {
  const _value = utcToLocal(value);
  const _onChange = (v: string) => {
    onChange(localToUTC(v));
  };
  const _onHasChanged = (newValue: string, oldValue: string) => {
    if (!oldValue && newValue) {
      onHasChanged?.({ id, value: newValue });
    } else {
      const datesAreEqual = isEqual(new Date(newValue), new Date(oldValue));

      if (!datesAreEqual) onHasChanged?.({ id, value: newValue });
    }
  };

  const displayLabel = getDisplayLabel(schema, uiSchema);

  return (
    <Box data-testid="datetime-widget">
      <DateTimePicker
        className="datetime-widget"
        value={_value}
        onChange={(value: string | null) => {
          _onChange(value || '');
          onHasChanged && setTimeout(() => _onHasChanged(value || '', _value), 0);
        }}
        disabled={disabled}
        readOnly={readOnly}
        slotProps={{
          textField: {
            autoFocus: autofocus,
            'aria-label': displayLabel ? label || schema.title : '',
          },
        }}
        sx={{
          '&.datetime-widget': {
            border: '1px solid #D5D7DA',
            borderRadius: '8px',
          },
          '&.date-time-widget.Mui-focused': {
            '& fieldset': {
              borderWidth: 0,
            },
          },
        }}
      />
    </Box>
  );
};

export default DateTimeWidget;
